export default function selectJiraLabelsByQuery(state, { source }) {
  return state.integrations.thirdPartyData[source].labels.byQuery
}
